import { sodApi } from '@/services/index'

export type SODAnalysisStatusType = {
  applicationId: string,
  status: number,
  statusDescription: string,
  isCompleted: boolean,
  hasDeveloperEvidence: boolean,
  hasImplementerEvidence: boolean
}

export const sodAnalysisApi = sodApi.injectEndpoints({
  endpoints: (builder) => ({
    getSodAnalysisStatus: builder.query<SODAnalysisStatusType, string>({
      query: (applicationId) => ({
        url: `/SODAnalysis/${applicationId}/status`,
        method: 'GET',
      }),
    }),
    getSodSummary: builder.query({
      query: ({ applicationId, evidenceType }) => ({
        url: `/SODAnalysis/${applicationId}/summary/${evidenceType}`,
        method: 'GET',
      }),
    }),
    getSodIdentifiers: builder.query({
      query: (evidenceType) => ({
        url: `/SODAnalysis/identifiers/${evidenceType}`,
        method: 'GET',
      }),
    }),
    getSodFile: builder.query({
      query: (applicationId) => ({
        url: `/SODAnalysis/${applicationId}`,
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
    createSodAnalysis: builder.mutation({
      query: (applicationId) => ({
        url: `/SODAnalysis/workbook/${applicationId}/create`,
        method: 'POST',
      }),
    }),
    getSodTotals: builder.query({
      query: (applicationId) => ({
        url: `/SODAnalysis/${applicationId}/totals`,
        method: 'GET',
      }),
    }),
    startSodPipeline: builder.mutation({
      query: ({ applicationId, developerIdentifiers, implementerIdentifiers }) => ({
        url: `/SODAnalysis/${applicationId}/start`,
        method: 'POST',
        body: {
          developerIdentifiers,
          implementerIdentifiers,
        },
      }),
    }),
    getSodSelectedIdentifiers: builder.query({
      query: (applicationId) => ({
        url: `/SODAnalysis/${applicationId}/identifiers`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useGetSodAnalysisStatusQuery,
  useGetSodSummaryQuery,
  useGetSodIdentifiersQuery,
  useLazyGetSodFileQuery,
  useGetSodFileQuery,
  useCreateSodAnalysisMutation,
  useGetSodTotalsQuery,
  useStartSodPipelineMutation,
  useGetSodSelectedIdentifiersQuery,
} = sodAnalysisApi
